module.exports = __webpack_public_path__ + "img/choose-bg.f6de63bb.svg";